module.exports = require("./hr-HR.js");